import { PaletteOptions } from '@material-ui/core/styles/createPalette';

const white = '#FFFFFF';
const black = '#000000';

const palette = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#002f27',
    main: '#00594f',
    light: '#3e867b',
  },
  secondary: {
    contrastText: white,
    dark: '#000f15',
    main: '#2b353b',
    light: '#545f65',
  },
  // Alineado con la escala --ds-color-error-* del Design System, para que los
  // controles de Material-UI y los del DS usen el mismo rojo.
  error: {
    contrastText: white,
    dark: '#dc2626',
    main: '#ff4842',
    light: '#f87171',
  },
  text: {
    primary: '#2b353b',
    secondary: '#a7b7be',
  },
  icon: '#2b353b',
  // divider: colors.grey[200],
} as PaletteOptions;

export default palette;
